module.exports = __webpack_public_path__ + "img/reorderOn.38541068.svg";